import Vue from 'vue'
import Vuex from 'vuex'
import humanway from './modules/humanway' 
//import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    humanway
  },
  strict: debug,
  //plugins: debug ? [createLogger()] : []
})